import {
  PROJECTASSIGN_FETCHING,
  PROJECTASSIGN_FAILED,
  PROJECTASSIGN_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROJECTASSIGN_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PROJECTASSIGN_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PROJECTASSIGN_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
